import { Event } from '@/event-bus/event';

export class MassEditShowWarningMultipleStatusesEvent extends Event<void> {}
